module.exports = __webpack_public_path__ + "static/media/arrow-left.72d86db9.svg";